import cn from 'classnames';
import * as React from 'react';

import * as styles from './QuickLinksBanner.css';

interface IQuickLinksBannerProps {
  hasLeftBorder?: boolean;
  hasRightBorder?: boolean;
  fixedWidth?: boolean;
}

export const QuickLinksBanner: React.FC<IQuickLinksBannerProps> = ({
  children,
  hasLeftBorder,
  hasRightBorder,
  fixedWidth,
}) => {
  return (
    <div
      className={cn(styles['banner'], {
        [styles['left-border']]: hasLeftBorder,
        [styles['right-border']]: hasRightBorder,
        [styles['fixed-width']]: fixedWidth,
      })}
    >
      {children}
    </div>
  );
};

QuickLinksBanner.displayName = 'QuickLinksBanner';
